import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_qsRUc8c8LpKl: {
	id: 'prd_qsRUc2DEV28c8LpKl'
	ident: 'prd_qsRUc8c8LpKl'
	sku: 'simple_premium_1w_6_49_4w_57_99_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 1
			iteration_count: 1
			price_id: 'prc_r8HZs2DEV2lbftyNK'
			amount: 15.99
			amount_usd: 6.49
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 6.49
			discount: 9.5
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_UO7GX2DEV2esSqIMM'
			amount: 57.99
			amount_usd: 57.99
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_qsRUc8c8LpKl, SubscriptionProduct>
const prd_qsRUc8c8LpKl = { ident: 'prd_qsRUc8c8LpKl' } as typeof _prd_qsRUc8c8LpKl

export default prd_qsRUc8c8LpKl
